import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerTerminalSelectComponent } from './container-terminal-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [ContainerTerminalSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [ContainerTerminalSelectComponent],
})
export class ContainerTerminalModule {}
